export default __webpack_public_path__ + "static/media/simulador.8ae4c78e.png";